import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import { partnerQrApi } from "../../app/slices/partnerInvoice/partnerTransactionSlice";
import BatukLogo from "../../../public/img/BatukLogo.png";
import { Button } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { DownloadIcon, Star } from "lucide-react";

export default function QrCodeTab({ partnerUserID, partnerUsername }) {
  // const [searchParams] = useSearchParams();
  // const partnerUsername = searchParams.get("partnerUsername");
  const dispatch = useDispatch();
  const location = useLocation();
  const { name, mobileNo } = location.state || {};
  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!partnerUsername) return;

    const fetchQr = async () => {
      setLoading(true);
      try {
        const response = await dispatch(
          partnerQrApi({ partnerUserID, partnerUsername }),
        );
        if (response.meta.requestStatus === "fulfilled") {
          setQrData(response.payload?.Qrbuffer);
        }
      } catch (error) {
        console.log("error fetching partner QR: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchQr();
  }, [partnerUsername, dispatch]);
  const getImageSrc = (value) => {
    if (!value) return null;
    if (value.startsWith("http") || value.startsWith("data:")) return value;
    return `data:image/png;base64,${value}`;
  };

  const imageSrc = getImageSrc(qrData);
  const handleDownload = () => {
    if (!imageSrc) return;

    const qrImg = new Image();
    const logoImg = new Image();

    qrImg.crossOrigin = "anonymous";

    qrImg.src = imageSrc;
    logoImg.src = BatukLogo;

    Promise.all([
      new Promise((resolve) => (qrImg.onload = resolve)),
      new Promise((resolve) => (logoImg.onload = resolve)),
    ]).then(() => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const width = 320;
      const height = 520;

      canvas.width = width;
      canvas.height = height;

      // Purple Background (same as UI)
      ctx.fillStyle = "#4a2a7d";
      ctx.fillRect(0, 0, width, height);

      // Logo
      ctx.drawImage(logoImg, 90, 20, 160, 70);

      // White QR Background
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(50, 110, 220, 220);

      // QR Image
      ctx.drawImage(qrImg, 50, 110, 220, 220);

      // Text
      ctx.fillStyle = "#ffffff";
      ctx.font = "bold 18px Arial";
      ctx.textAlign = "center";

      ctx.fillText(`Name:- ${name || ""}`, width / 2, 370);
      ctx.fillText(`Mobile:- ${mobileNo || ""}`, width / 2, 405);

      // Username + Star
      ctx.fillText(`Code:- ${partnerUsername} ⭐`, width / 2, 440);

      // Download
      const link = document.createElement("a");
      link.download = `${partnerUsername}_QR.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };
  return (
    <Box display="flex" justifyContent="center" mt={4}>
      {/* <Paper
        elevation={2}
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          borderRadius: 3,
          minWidth: 260,
          minHeight: 260,
          color: "#fff",
          justifyContent: "center",
          backgroundColor: "#4a2a7d",
        }}
      > */}
      <div
        style={{
          backgroundColor: "#4a2a7d",
          padding: "15px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          borderRadius: 3,
          minWidth: 260,
          minHeight: 260,
          color: "#fff",
          justifyContent: "center",
        }}
      >
        {loading && <CircularProgress />}

        {!loading && imageSrc && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img src={BatukLogo} alt="batuk" width="160px"></img>
            <img
              src={imageSrc}
              alt="Partner QR Code"
              width={220}
              height={220}
              style={{
                objectFit: "contain",
                // padding: "10px",
                borderRadius: "3px",
                margin: "10px",
              }}
            />
            <h3
              style={{
                color: "white",
                marginBottom: "5px",
                fontSize: "16px",
                fontWeight: 600,
                overflowWrap: "break-word",
              }}
            >
              Name:-
              {name}
            </h3>
            <h3
              style={{
                color: "white",
                marginBottom: "5px",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              Mobile:-
              {mobileNo}
            </h3>
            <h3
              style={{
                color: "white",
                marginBottom: "5px",
                fontSize: "16px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              Code:-
              {partnerUsername}⭐
            </h3>
          </div>
        )}
        <Button
          onClick={handleDownload}
          style={{
            border: "0.3px solid #fff",
            backgroundColor: "rgb(199, 158, 70)",
            color: "#fff",
            padding: "5px 10px",
            borderRadius: "5px",
            display: "flex",
            fontWeight: "bold",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <DownloadIcon />
          QR Code
        </Button>

        {!loading && !imageSrc && (
          <Typography variant="body2" color="text.secondary">
            No QR code available
          </Typography>
        )}
      </div>
      {/* </Paper> */}
    </Box>
  );
}
